<template>
  <div class="items">
    <template v-if="items.length">
      <button
        class="item"
        :class="{ 'is-selected': index === selectedIndex }"
        v-for="(item, index) in items"
        :key="index"
        @click="selectItem(index)"
      >
        {{ item.username }}
      </button>
    </template>
    <div class="item" v-else>
      No result
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
    },

    command: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      selectedIndex: 0,
    }
  },

  watch: {
    items() {
      this.selectedIndex = 0
    },
  },

  methods: {
    onKeyDown({ event }) {
      if (event.key === 'ArrowUp') {
        this.upHandler()
        return true
      }

      if (event.key === 'ArrowDown') {
        this.downHandler()
        return true
      }

      if (event.key === 'Enter') {
        this.enterHandler()
        return true
      }

      return false
    },

    upHandler() {
      this.selectedIndex = ((this.selectedIndex + this.items.length) - 1) % this.items.length
    },

    downHandler() {
      this.selectedIndex = (this.selectedIndex + 1) % this.items.length
    },

    enterHandler() {
      this.selectItem(this.selectedIndex)
    },

    selectItem(index) {
      const item = this.items[index]

      if (item) {
        this.command({ id: item.username })
      }
    },
  },
}
</script>

<style lang="scss">
.items {
  padding: 10px;
  position: relative;
  border-radius: 8px;
  background: #f8f8f8;
  color: rgba(0, 0, 0, 0.8);
  overflow: hidden;
  font-family: inherit;
}
.item {
  display: block;
  margin: 0;
  width: 100%;
  text-align: left;
  font-family: inherit;
  font-size: 14px;
  background: transparent;
  padding: 10px;
  border-radius: 3px;
  border: none;
  cursor: pointer;
  &:hover {
    background: #fff;
  }

  &.is-selected {
    background: #fff;
  }
}
</style>